export const GET_PHONE_TYPES_REQUEST = "GET_PHONE_TYPES_REQUEST"
export const GET_PHONE_TYPES_SUCCESS = "GET_PHONE_TYPES_SUCCESS"
export const GET_PHONE_TYPES_ERROR = "GET_PHONE_TYPES_ERROR"
export const GET_PHONE_TYPE_REQUEST = "GET_PHONE_TYPE_REQUEST"
export const GET_PHONE_TYPE_SUCCESS = "GET_PHONE_TYPE_SUCCESS"
export const GET_PHONE_TYPE_ERROR = "GET_PHONE_TYPE_ERROR"
export const CREATE_PHONE_TYPE_REQUEST = "CREATE_PHONE_TYPE_REQUEST"
export const CREATE_PHONE_TYPE_SUCCESS = "CREATE_PHONE_TYPE_SUCCESS"
export const CREATE_PHONE_TYPE_ERROR = "CREATE_PHONE_TYPE_ERROR"
export const EDIT_PHONE_TYPE_REQUEST = "EDIT_PHONE_TYPE_REQUEST"
export const EDIT_PHONE_TYPE_SUCCESS = "EDIT_PHONE_TYPE_SUCCESS"
export const EDIT_PHONE_TYPE_ERROR = "EDIT_PHONE_TYPE_ERROR"
export const DELETE_PHONE_TYPE_REQUEST = "DELETE_PHONE_TYPE_REQUEST"
export const DELETE_PHONE_TYPE_SUCCESS = "DELETE_PHONE_TYPE_SUCCESS"
export const DELETE_PHONE_TYPE_ERROR = "DELETE_PHONE_TYPE_ERROR"